import { createSlice } from "@reduxjs/toolkit";
import {getAllCategoriesThunk} from './thunk';


export const initialState = {
    categoriesList: [],
    error: {},
    isLoading:false,
};

const CategorySlice = createSlice({
    name: 'CategorySlice',
    initialState,
    reducer: {},
    extraReducers: (builder) => {

          //get all categories
        builder.addCase(getAllCategoriesThunk.pending, (state, action) => {
             state.isLoading = true;
        });

          builder.addCase(getAllCategoriesThunk.fulfilled, (state, action) => { 
                state.categoriesList = action.payload.data;
                state.isLoading = false
        });

        builder.addCase(getAllCategoriesThunk.rejected, (state, action) => {
            state.error = action.payload.success || null;
            state.isLoading = false;
        });
             
    }
});

export default CategorySlice.reducer;